import { render, staticRenderFns } from "./LaudoAmostras.vue?vue&type=template&id=08c12d9b&"
import script from "./LaudoAmostras.vue?vue&type=script&lang=js&"
export * from "./LaudoAmostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports